import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { PhoenixObjectDataset } from 'app/model/dataset/phoenix.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PhoenixObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class PhoenixObjectDatasetAdapter extends TabularTypeDatasetAdapter<PhoenixObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: PhoenixObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(PhoenixObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: PhoenixObjectDataset): Promise<PhoenixObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, PhoenixObjectDataset.MODEL);
    }
}
